module.exports = __webpack_public_path__ + "media/packs/base/stylesheets/fonts/baskerville_regular-80c8839fc012c2ca7057662689b23e1e.woff";